import React from "react";
import { Link } from "react-router-dom";
import { ar_routes } from "../router/ar_routes";

interface ArabicBreadcrumbsProps {
  title: string;
}

const ArabicBreadcrumbs = ({ title }: ArabicBreadcrumbsProps) => (
  <div className="breadcrumb-bar">
    <div className="container">
      <div className="row align-items-center text-center">
        <div className="col-md-12 col-12">
          <h2 className="breadcrumb-title">{title}</h2>
          <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={ar_routes.home}>الرئيسية</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {title}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
);

export default ArabicBreadcrumbs;
